<template>
  <v-container>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                    Popis djelatnika koji su odslušali SUMIT radionice
                    <v-icon slot="divider" style="padding-bottom: 2px;" @click="getData()">mdi-refresh</v-icon>
                </span>

        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="6">
        <v-text-field
            outlined
            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-autocomplete
            outlined
            :items="workshop"
            item-text="text"
            item-value="value"
            hide-details
            label="Odaberi radionicu.."
            v-model="selected_workshop"
            dense
            @change="getData()"
        ></v-autocomplete>
      </v-col>

      <!--    :options.sync="options"-->
      <!--    :server-items-length="serverItemsLength"-->
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>

          <template v-slot:[`item.id`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs"
                         v-on="on" class="mx-1" x-small min-height="30"
                         :color="'primary'"
                         @click="handleAction(item)">
                    <v-icon
                        ripple small class="pa-0" color="white"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </template>
                <span>Detaljan pregled</span>
              </v-tooltip>
          </template>

          <template v-slot:[`item.radionice`]="{ item }">
            <p v-if="item.radionice === 'moodle'" style="color: #084776 !important;" class="font-weight-bold mb-0">Školarac</p>
            <p v-else-if="item.radionice === 'gsuite'" style="color: #084776 !important;" class="font-weight-bold mb-0">Google alate</p>
            <p v-else-if="item.radionice === '2020-08-24'" style="color: #084776 !important;" class="font-weight-bold mb-0">Edukacija nastavnika za korištenje informacijskih tehnologija</p>
          </template>

          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import {serverBus} from "@/main";

import {serverBus} from "@/main";

export default {
  name: "WorkshopReports",
  created() {
    if(localStorage.getItem('workshop_search')){
      this.search = localStorage.getItem('workshop_search')
    }
    if(localStorage.getItem('selected_workshop')){
      this.selected_workshop = localStorage.getItem('selected_workshop')
    }
    serverBus.$on('reload-all-data', () => {
      this.search = ''
      this.getData();
    })
    this.getData();
  },
   watch:{
    search:{
      handler(){
        localStorage.setItem('workshop_search', this.search)
      },
      deep: true
    },
    selected_workshop:{
      handler(){
        localStorage.setItem('selected_workshop', this.selected_workshop)
      },
      deep: true
    }
  },
  methods: {
    getData(){
        this.$axios.get('/ostalo/report_workshop_name/' + this.selected_workshop).then(response => {
          // console.log(response.data)
          this.items = response.data;
          for (var i = 0; i < this.items.length; i++){
            if(this.items[i].id === null){
              delete this.items[i]
            }
          }
        });
    },

    handleAction(item) {
      this.$router.push({name: 'SingleEmployeeTableView', params: {djelatnik_id: item.id}})
      // serverBus.$emit('show-employee-profile', item);
    },
  },
  data: function () {
    return {
      items: [],
      cantons: [],
      loading: false,
      breadcrumbs: [{text: "Administracija"}, {text: "Izvještaji"}, {text: "Popis SUMIT koordinatora"}],
      search: '',
      selected_workshop: 'moodle',
      workshop: [
        {
          value: 'moodle',
          text: 'Školarac',
        },
        {
          value: 'gsuite',
          text: 'Google alate',
        },
        {
          value: '2020-08-24',
          text: 'Edukacija nastavnika za korištenje informacijskih tehnologija',
        }
      ],
      headers: [
        {
          text: 'Ime i prezime',
          value: 'full_name',
        },
        {text: 'eduID', value: 'aai_email'},
        {text: 'Telefon', value: 'phone'},
        {text: 'Radionica', value: 'radionice'},
        {text: 'Akcije', value: 'id'},
      ],
    }
  }
}
</script>

<style scoped>

</style>